/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'

const $nsid = 'us.edriffles.radlib.private.getFeed'

type $nsid = typeof $nsid

export { $nsid }

type Record$0 = {
  $type?: 'us.edriffles.radlib.private.getFeed#record'
  space: string
  repo: l.DidString
  collection: l.NsidString
  rkey: l.RecordKeyString
  cid: l.CidString
  record: l.LexMap
  createdAt: l.DatetimeString
  updatedAt: l.DatetimeString
}

export type { Record$0 as Record }

const record$0 = /*#__PURE__*/ l.typedObject<Record$0>(
  $nsid,
  'record',
  /*#__PURE__*/ l.object({
    space: /*#__PURE__*/ l.string(),
    repo: /*#__PURE__*/ l.string({ format: 'did' }),
    collection: /*#__PURE__*/ l.string({ format: 'nsid' }),
    rkey: /*#__PURE__*/ l.string({ format: 'record-key' }),
    cid: /*#__PURE__*/ l.string({ format: 'cid' }),
    record: /*#__PURE__*/ l.lexMap(),
    createdAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
    updatedAt: /*#__PURE__*/ l.string({ format: 'datetime' }),
  }),
)

export { record$0 as record }

export const $params = /*#__PURE__*/ l.params({
  space: /*#__PURE__*/ l.string(),
  limit: /*#__PURE__*/ l.optional(
    /*#__PURE__*/ l.withDefault(
      /*#__PURE__*/ l.integer({ minimum: 1, maximum: 100 }),
      50,
    ),
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string({ maxLength: 128 })),
})

export type $Params = l.InferOutput<typeof $params>

export const $output = /*#__PURE__*/ l.jsonPayload({
  providerDid: /*#__PURE__*/ l.string({ format: 'did' }),
  space: /*#__PURE__*/ l.string(),
  feed: /*#__PURE__*/ l.array(
    /*#__PURE__*/ l.ref<Record$0>((() => record$0) as any),
    { maxLength: 100 },
  ),
  cursor: /*#__PURE__*/ l.optional(/*#__PURE__*/ l.string()),
})

export type $Output<B = l.BinaryData> = l.InferPayload<typeof $output, B>
export type $OutputBody<B = l.BinaryData> = l.InferPayloadBody<
  typeof $output,
  B
>

/** Return a viewer-authorized private post feed from the hosting PDS. This is not a public AppView or Relay feed. */
const main = /*#__PURE__*/ l.query($nsid, $params, $output)

export { main }

const $lxm = $nsid

type $lxm = typeof $lxm

export { $lxm }
